export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};
export const DEFAULT_MULTIPLE = { value: 0, shape: "" };

export const DEFAULT_CURRENCY = {
  ...DEFAULT_MULTIPLE,
  name: "",
  shortName: "",
  symbol: "",
  type: "",
  exchangeRate: 1,
  multiples: [],
};

export const CURRENCY_TYPES = [
  {
    value: "Local",
    label: "Local",
  },
  {
    value: "Foreign Exchange",
    label: "Foreign Exchange",
  },
];

export const CURRENCY_SHAPES = [
  {
    value: "Coins",
    label: "Coins",
  },
  {
    value: "Notes",
    label: "Notes",
  },
];
